import React from "react";
import { observer } from "mobx-react-lite";
import { DeleteModal } from "../../components";
import { useStore } from "../../helpers";
import { useDeleteServiceRequestSubject } from "./sr-hooks";
import { toJS } from "mobx";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";

export const ServiceRequestDelete = observer((props: any) => {
  const { serviceRequestsStore } = useStore();
  const { mutate } = useDeleteServiceRequestSubject();
  const {t} =useTranslation("service_request_home")
  const { projectid } = useParams();
  const closeModal = () => {
    serviceRequestsStore.update_modal_status("deleteServiceRequest", false);
  };
  return (
    <div>
      <DeleteModal
        isOpen={serviceRequestsStore.modals.deleteServiceRequest}
        onDeleteClick={() => {
          if (serviceRequestsStore.activeServiceRequest.id) {
            console.log(toJS(serviceRequestsStore.activeServiceRequest.id));
            console.log(toJS(serviceRequestsStore.activeServiceRequest));
            // @ts-ignore
            mutate({
              id: serviceRequestsStore.activeServiceRequest.id,
              projectid: parseInt(projectid),
            });
            closeModal();
          }
        }}
        desc={t("delete_sr")}
        onCancelClick={closeModal}
      />
    </div>
  );
});
